import {
  Component,
  OnInit,
  Input,
  EventEmitter,
  Output,
  OnChanges,
  SimpleChanges,
  ChangeDetectorRef,
  AfterViewInit,
  ViewChild,
  ElementRef,
  HostListener,
} from '@angular/core';
import { Router } from '@angular/router';
import { ApiService, ElectronService } from '@pos-app/core-ui';
import { KEYS } from '@pos-app/data';
import { ToastrService } from 'ngx-toastr';
import { Subject, BehaviorSubject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CoreUiModule } from '../../../../../../../../libs/core-ui/src/lib/core-ui.module';
import { NgIf, NgFor, NgStyle, AsyncPipe } from '@angular/common';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-help-how-to',
    styleUrls: ['./help-how-to.component.scss'],
    templateUrl: './help-how-to.component.html',
    imports: [CoreUiModule, NgIf, MatIcon, NgFor, NgStyle, AsyncPipe]
})
export class HelpHowToComponent implements OnInit, OnChanges, AfterViewInit {
  @Input() helpHowToComponent: any;
  @ViewChild('scrollContainer') scrollContainer: ElementRef;

  myHelpComponents: any;
  setIframeBaseUrlTimeout$ = new BehaviorSubject<boolean>(false);
  showScrollArrows: boolean = false;
  unSubscribe$ = new Subject<void>();

  constructor(
    private router: Router,
    private apiService: ApiService,
    private cdr: ChangeDetectorRef,
    private electronService: ElectronService,
    private toastr: ToastrService,
  ) {}

  ngOnInit() {
    this.myHelpComponents = this.helpHowToComponent;
  }

  ngAfterViewInit() {
    // Check if scroll arrows should be shown after view is initialized
    setTimeout(() => {
      this.checkScrollArrows();
    }, 100);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.checkScrollArrows();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.helpHowToComponent?.currentValue) {
      this.myHelpComponents = changes.helpHowToComponent?.currentValue;
      this.cdr.detectChanges();
      setTimeout(() => {
        this.checkScrollArrows();
      }, 100);
    }
  }

  checkScrollArrows(): void {
    if (this.scrollContainer?.nativeElement) {
      const element = this.scrollContainer.nativeElement;
      this.showScrollArrows = element.scrollWidth > element.clientWidth;
      this.cdr.detectChanges();
    }
  }

  setIframeBaseUrl(myHelpComponent: any) {
    if (this.setIframeBaseUrlTimeout$.getValue()) {
      return;
    } else if (!this.setIframeBaseUrlTimeout$.getValue()) {
      this.setIframeBaseUrlTimeout$.next(true);
      setTimeout(() => {
        try {
          const stored = localStorage.getItem(KEYS.jdeSession);
          const userProfile = stored ? JSON.parse(stored) : {};
          localStorage.setItem(KEYS.jdeSession, JSON.stringify({ ...userProfile, iframeBaseUrl: myHelpComponent?.url }));
        } catch (e) {
          console.warn('[HelpHowTo] localStorage access blocked or invalid JSON', e);
        }

        // get base url of application
        const baseUrl = window.location.origin === 'http://localhost:4200' ? 'https://central-py.arb.com.au' : window.location.origin;

        try {
          if (myHelpComponent?.loadInNewTab) {
            this.navigateToExternalLink(myHelpComponent?.url);
          } else if (!myHelpComponent?.loadInNewTab && myHelpComponent?.url.includes(baseUrl)) {
            const url = myHelpComponent?.url.split(baseUrl);
            if (url.length && url[1].includes('download/file/')) {
              const myId = url[1].split('download/file/')[1];
              this.openLink(myId);
            } else {
              this.router.navigateByUrl(url[1]);
            }
          } else {
            this.router.navigateByUrl(`/central/help-how-to/${myHelpComponent?.label}`);
          }
        } catch (e) {
          console.error('[HelpHowTo] navigation error', e);
        } finally {
          this.setIframeBaseUrlTimeout$.next(false);
        }
      }, 1000);
    }
  }

  navigateToExternalLink(link: string) {
    window.open(link);
  }

  // Scroll the help component list to the right
  scrollRightb(): void {
    this.scrollHelpComponentList(300);
  }

  // Scroll the help component list to the left
  scrollLeftb(): void {
    this.scrollHelpComponentList(-300);
  }

  // Helper method to scroll the help component list
  private scrollHelpComponentList(offset: number): void {
    if (this.scrollContainer?.nativeElement) {
      this.scrollContainer.nativeElement.scrollLeft += offset;
    }
  }

  private openLink(id: string, isOpeningAsUrl = false) {
    return this.apiService
      .getDownloadUrl(id, isOpeningAsUrl)
      .pipe(takeUntil(this.unSubscribe$))
      .subscribe((res) => {
        this.toastr.success('File downloaded successfully');
        if (this.electronService.isElectron) {
          if (isOpeningAsUrl) {
            this.electronService.openLinkNatively(res.fileUrl);
          } else {
            this.electronService.openFileNatively(res.fileUrl);
          }
          return;
        }
        window.open(res.fileUrl, isOpeningAsUrl ? '_blank' : '_self');
      });
  }
}

